function GetBrowser() {
  try {
    const userAgent = (navigator.userAgent || '').toLowerCase();
    const uaData = navigator.userAgentData;

    let isMobile = false;
    if (
      /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i.test(
        userAgent
      )
    ) {
      isMobile = true;
    }

    let browserName = 'unknown';

    // Modern browsers (Chrome, Edge, Opera)
    if (uaData?.brands) {
      try {
        browserName = uaData.brands.map((b) => b.brand).join(', ');
      } catch (e) {
        browserName = 'unknown';
      }
    }
    // Fallback for Safari / Firefox / iOS
    else {
      if (userAgent.includes('firefox')) {
        browserName = 'firefox';
      } else if (
        userAgent.includes('safari') &&
        !userAgent.includes('chrome') &&
        !userAgent.includes('edge') &&
        !userAgent.includes('chromium')
      ) {
        browserName = 'safari';
      } else if (userAgent.includes('chrome')) {
        browserName = 'chrome';
      } else if (userAgent.includes('edge')) {
        browserName = 'edge';
      } else if (userAgent.includes('opera') || userAgent.includes('opr')) {
        browserName = 'opera';
      } else if (navigator.appName) {
        browserName = navigator.appName.toLowerCase();
      }
    }

    if (isMobile) {
      browserName += ' mobile';
    }

    return browserName;
  } catch (error) {
    console.error('Error detecting browser:', error);
    return 'unknown';
  }
}

export default GetBrowser;
